module.exports = __webpack_public_path__ + "static/media/video.3de888ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/LPC/video.jpg
// module id = 292
// module chunks = 0